import React, { memo } from 'react';
import { isMobile } from 'react-device-detect';
import { DEMO_USER_PICTURE } from '../../../../common/common';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { BsUpload, FiCamera, IoIosArrowBack } from '../../../../components/icons';
const base = 'upload/photos/';
const AVATAR_ARRAY = [1, 2, 3].map((_i) => `${base}doctube_channel_avatar_${_i}.png`);

const ProfilePicSelectionForm = ({
  onNextBtnClick,
  onUpload,
  onAvatorSelect,
  selectedProfilePicture
}) => {
  return (
    <>
      <div className="col-12 shareLoginV2FormRow dt_steps dt_ProfileManagement p-0 position-relative">
        <div className="dt_step_panel">
          <h2 className="text-black fw-medium fs-16 mb-5 text-center">
            Upload your profile picture here! It wil represent you in front of milions of patients!
            <span className="mx-auto d-block rounded bg-primary dt_stepTextBtmBorder mt-3"></span>
          </h2>

          <div className="dt_step_form mx-auto mw-100">
            {selectedProfilePicture && (
              <div className="dt_profilePic_preview">
                <div className="dt_channelIcon mx-auto mb-4">
                  <div className="dt_channelIconIn">
                    <LazyImage
                      src={
                        typeof selectedProfilePicture == 'object'
                          ? URL.createObjectURL(selectedProfilePicture)
                          : selectedProfilePicture
                      }
                      className="object-fit-cover w-100 h-100 float-start"
                      fallback_image={DEMO_USER_PICTURE}
                    />
                  </div>
                </div>
              </div>
            )}

            <form>
              <div className="d-flex dr_ImageSelectBtn mb-4">
                {isMobile && (
                  <button
                    className="rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-primary fw-medium me-4 px-2 py-4 uploadPicBtn position-relative"
                    type="button"
                  >
                    <input
                      className="position-absolute top-0 start-0 w-100 h-100 rounded-circle bg-danger z-3 opacity-0"
                      type="file"
                      id="imageFile"
                      capture="user"
                      accept="image/*"
                      onChange={onUpload}
                      onClick={(e) => {
                        e.target.value = '';
                      }}
                    />
                    <FiCamera customClass="fs-3  me-2" /> Take a photo
                  </button>
                )}
                <button
                  className="rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-primary fw-medium ms-0 px-2 py-4 uploadPicBtn position-relative"
                  type="button"
                >
                  <input
                    className="position-absolute top-0 start-0 w-100 h-100 rounded-circle bg-danger z-3 opacity-0"
                    type="file"
                    id="imageFile"
                    accept="image/*"
                    onChange={onUpload}
                    onClick={(e) => {
                      e.target.value == '';
                    }}
                  />
                  <BsUpload customClass="fs-3 text-white me-2" />
                  Upload photo
                </button>
              </div>
              <h4 className="fs-4 text-black fw-medium mb-4 text-center">
                <span className="d-block text-center mb-2">OR</span>
                <span className="d-block text-center">Select an avatar</span>
              </h4>
              {/* Avatar start */}
              <div className="d-flex dt_defaultImg_selection justify-content-center mb-4 gap-4">
                {AVATAR_ARRAY?.map((_avatar, _idx) => (
                  <div className="dt_imgBtn">
                    <div className="dt_imgBtnIn rounded-3 position-relative overflow-hidden">
                      <input
                        className="position-absolute top-0 start-0 w-100 h-100 z-3 opacity-0 cursorPointer"
                        type="radio"
                        value={_avatar}
                        name="options"
                        checked={selectedProfilePicture == _avatar}
                        // id={`avatar${_idx + 1}`}
                        onChange={(e) => {
                          onAvatorSelect(_avatar);
                        }}
                      />
                      <label
                        className="position-relative border border-light p-2 rounded-3 overflow-hidden"
                        htmlFor={`avatar${_idx + 1}`}
                      >
                        <LazyImage
                          src={_avatar}
                          alt="Select Image"
                          className="object-fit-cover w-100 h-100 float-start"
                        />
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              {/* Avatar end */}

              <div className="d-flex dt_step_Submit mt-4 p-0">
                <button
                  className="dt_backBtn rounded-3 text-dark d-flex align-items-center justify-content-center fs-4 btn btn-light fw-medium me-2 p-4"
                  type="button"
                  //   onClick={registerChannel}
                  onClick={() => onNextBtnClick(1)}
                >
                  <IoIosArrowBack customClass={'fs-2 text-black'} />
                  {/* Skip */}
                </button>
                <button
                  type="button"
                  className={`dt_nextBtn rounded-3 text-white flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-secondary fw-medium ms-2 p-4 ${
                    selectedProfilePicture ? '' : 'disabled'
                  }`}
                  disabled={selectedProfilePicture ? false : true}
                  onClick={() => onNextBtnClick(3)}
                >
                  Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(ProfilePicSelectionForm);